import React from 'react'

const Footer = () => {
  return (
    <div dangerouslySetInnerHTML={{__html: footerHTML}}>
    </div>
  )
}

export default Footer

const footerHTML = `
<style>
footer {
  max-width: 1300px;
  margin: auto;
}
@media (min-width: 992px) {
  footer {
    max-width: 300px;
  }
  .col-md-12 {
      width: 100%;
  }
}
footer #footer-menu-row .brand {
    text-align: center;
    margin: auto;
    margin-top: 25px;
}
footer nav.privacy-menu {
  text-align: center;
}
footer .privacy-menu ul li {
  margin-right: 16px;
  text-align: center;
  display: inline-block;
  /* float: left; */
}
footer .privacy-menu ul li a {
  color: black;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 1.2em;
}
#footer-menu-row > div > div > div > a > img {
  max-width: 265px;
  margin: 20px;
}
</style>
<div id="footer-menu-row" class="row">
                        <div class="col-md-12">
						<div class="col-md-12">
							<div class="brand">
								<a href="https://www.onepointesolutions.com" title="Go Home"><img src="https://www.onepointesolutions.com/wp-content/themes/onepointe-wordpress/img/onepointe-logo.png"></a>
							</div>
                            <nav class="privacy-menu">
								<div class="menu-privacy-policy-terms-menu-container"><ul id="menu-privacy-policy-terms-menu" class="menu"><li id="menu-item-202" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-202"><a href="https://www.onepointesolutions.com/terms-conditions/">Terms &amp; Conditions</a></li>
<li id="menu-item-201" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-privacy-policy menu-item-201"><a href="https://www.onepointesolutions.com/privacy-policy/">Privacy Policy</a></li>
</ul></div>                            </nav>
						</div>
					</div>
`
